export const platformStats = [
  { label: '累计服务学员', value: 469800, suffix: '+ 人' },
  { label: '合作高校', value: 128, suffix: ' 所' },
  { label: '高清课程', value: 3500, suffix: '+ 门' },
  { label: '学员满意度', value: 98.6, suffix: '%' },
];